import React from 'react';
import { Menu, Item, animation } from 'react-contexify';
import TreeNode from './TreeNode';
import ExperimentPlateNode from './ExperimentPlateNode';
import WithContextMenu from './WithContextMenu';
import { ExpeirmentNodeProps } from 'business/models/CustomModels';

export default function ExperimentNode(props: ExpeirmentNodeProps) {
  const node = props.data as any;

  function NodeMenu() {
    return (
      <Menu id={node.id} animation={animation.zoom} style={{ zIndex: 100 }}>
        <Item onClick={() => {}} data={node}>
          Experiment Info
        </Item>
      </Menu>
    );
  }

  const allProps = {
    ...props,
    link: node.extra !== null && `/exp/${node.extra.id}`,
    menu: NodeMenu,
  };

  const ContextifiedTreeNode = WithContextMenu(TreeNode);

  return (
    <ContextifiedTreeNode key={node.id} {...allProps}>
      <div
        id={`experiment-node-menu${node.type + node.id}`}
        className="nav-item collapse"
      >
        {node.extra === null ||
          node.extra.plates === null ||
          node.extra.plates.map((plate) => (
            <ExperimentPlateNode key={plate.id} {...plate} sublevel={node.sublevel + 1} />
          ))}
      </div>
    </ContextifiedTreeNode>
  );
}
